import { UpgradeButton } from "./premium-lock";

/**
 * Renders a server message and, when it is a freemium quota denial, the
 * upgrade CTA right next to it.
 */
export function isQuotaMessage(message: string | null | undefined): boolean {
  return typeof message === "string" && message.includes("Upgrade to Premium");
}

export function QuotaNotice({
  message,
  tone = "error",
  className = "",
}: {
  message: string | null | undefined;
  tone?: "error" | "warning";
  className?: string;
}) {
  if (!message) return null;
  const quota = isQuotaMessage(message);
  const palette = quota
    ? "border-primary/25 bg-primary/10 text-foreground"
    : tone === "warning"
      ? "border-warning/25 bg-warning/10 text-warning"
      : "border-destructive/25 bg-destructive/10 text-destructive";

  return (
    <div className={`rounded-[22px] border px-4 py-3 text-[12.5px] leading-relaxed ${palette} ${className}`}>
      <p>{message}</p>
      {quota ? <UpgradeButton className="mt-3" reason={message} /> : null}
    </div>
  );
}
